import type { ReportCellDisplay } from '@/views/report/report-cell-display';

export const compareCellDisplay = (
  beforeValue: string,
  values: [string, string, string, string],
): ReportCellDisplay => ({
  kind: 'compare',
  beforeValue,
  values,
});

export default compareCellDisplay;
